<template>
  <a-modal
    width="1200px"
    :title="currentItem.name"
    v-model:visible="visible"
    :footer="false">
  <div class="dataset-detail">
   <!-- <div class="detail-page-title">
      {{ currentItem.name }}
      <a-button type="primary">返回</a-button>
    </div>-->
    <a-tabs>
      <a-tab-pane key="1" tab="任务信息">
        <div class="paragraph-title">
          基本信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label">任务ID：</div>
            <div class="value">{{ currentItem.id }}</div>
          </div>
          <div class="info-item">
            <div class="label">名称：</div>
            <div class="value">{{ currentItem.name }}</div>
          </div>
          <div class="info-item">
            <div class="label">任务类型：</div>
            <div class="value">{{ getTaskName(currentItem.taskTypeId) }}</div>
          </div>
          <div class="info-item">
            <div class="label">说明：</div>
            <div class="value">{{ currentItem.description?currentItem.description:'--' }}</div>
          </div>
          <div class="info-item">
            <div class="label">发布人：</div>
            <div class="value">{{ getUserName(currentItem.createUserId) }}</div>
          </div>
          <div class="info-item">
            <div class="label">任务总量：</div>
            <div class="value">{{ taskNumber }}</div>
          </div>
          <div class="info-item">
            <div class="label">发布时间：</div>
            <div class="value">{{ getDateTime(currentItem.createTime) }}</div>
          </div>
          <div class="info-item">
            <div class="label">要求完成时间：</div>
            <div class="value">{{ getDateTime(currentItem.planFinishTime) }}</div>
          </div>
        </div>
        <div class="paragraph-title">
          标注信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label" style="text-align: left;width: 50px;">状态：</div>
            <div class="value">{{ currentItem.locking == 'success' ? '任务处理中' : getStateName(currentItem.state) }}</div>
          </div>
         <!-- <div class="info-item">
            <div class="label">智能标注：</div>
            <div class="value">{{ currentItem.smart }}</div>
          </div>-->
          <div class="info-item">
            <div class="label">标注进度：</div>
            <div class="value">{{ currentItem.progress?currentItem.progress:'--' }}</div>
          </div>
          <!--<div class="info-item">
            <div class="label">标注子任务数：</div>
            <div class="value">{{ currentItem.taskNumber?currentItem.taskNumber:'&#45;&#45;' }}</div>
          </div>-->
          <div class="custom-table" v-if="subList.length>0">
            <div class="table-row tab">
              <p style="width: 100%">子任务名称</p>
              <p style="width: 100%">标注员</p>
              <p style="width: 100%">分配数量</p>
<!--              <p style="width: 100%">标注数量</p>-->
            </div>
            <div class="table-row"
              v-for="(item, index) in subList || []"
              :key="index">
              <p style="width: 100%">{{ item.taskName }}</p>
              <p style="width: 100%">{{ getUserName(item.name) }}</p>
              <p style="width: 100%">{{ item.taskNum }}</p>
<!--              <p style="width: 100%">{{ item.value }}</p>-->
            </div>
            <!--<div class="table-row"
                 v-for="(item, index) in info.list2 || []"
                 :key="index">
              <p style="width: 100%">{{ item.name }}</p>
              <p style="width: 100%">{{ item.value }}</p>
            </div>-->
          </div>
          <!--<div class="custom-table">
            <div class="table-row">
              <p style="width: 50%">审核员</p>
              <p style="width: 50%">审核数量</p>
            </div>
            <div class="table-row"
              v-for="(item, index) in info.list2 || []"
              :key="index">
              <p style="width: 50%">{{ item.name }}</p>
              <p style="width: 50%">{{ item.value }}</p>
            </div>
          </div>-->

        </div>
      <!--  <div class="paragraph-title">
          审核信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label">审核进度：</div>
            <div class="value">{{ currentItem.progress?currentItem.progress:'&#45;&#45;' }}</div>
          </div>
          <div class="info-item">
            <div class="label">审核子任务数：</div>
            <div class="value">{{ currentItem.subTaskCount }}</div>
          </div>
          <div class="info-item">

          </div>
          <div class="custom-table">
            <div class="table-row tab">
              <p style="width: 100%">子任务名称</p>
              <p style="width: 100%">审核员</p>
              <p style="width: 100%">分配数量</p>
              <p style="width: 100%">审核数量</p>
            </div>
            <div class="table-row"
                 v-for="(item, index) in info.list1 || []"
                 :key="index">
              <p style="width: 100%">{{ item.name }}</p>
              <p style="width: 100%">{{ item.value }}</p>
              <p style="width: 100%">{{ item.value }}</p>
              <p style="width: 100%">{{ item.value }}</p>
            </div>
            &lt;!&ndash;<div class="table-row"
                 v-for="(item, index) in info.list2 || []"
                 :key="index">
              <p style="width: 100%">{{ item.name }}</p>
              <p style="width: 100%">{{ item.value }}</p>
            </div>&ndash;&gt;
          </div>
          &lt;!&ndash;<div class="custom-table">
            <div class="table-row">
              <p style="width: 50%">审核员</p>
              <p style="width: 50%">审核数量</p>
            </div>
            <div class="table-row"
              v-for="(item, index) in info.list2 || []"
              :key="index">
              <p style="width: 50%">{{ item.name }}</p>
              <p style="width: 50%">{{ item.value }}</p>
            </div>
          </div>&ndash;&gt;

        </div>-->
      </a-tab-pane>
      <a-tab-pane key="2" tab="标注数据" forceRender>
        <PicList ref="picList"
                 :dataset-id="currentItem.datasetId"
                 @settotal="setTotalCount"></PicList>
       <!-- <div class="pic-wrap">
          <div class="pic-item"
            v-for="(item, index) in picList"
            :key="index">
            <img :src="appConfig.baseImgUrl + item.accessSrc" alt="" @click="openPicDialog">
            <p class="name">{{ item.id }}</p>
          </div>
        </div>
        <a-pagination
          :current="page.pageNum"
          show-quick-jumper
          :pageSize="10"
          :total="total"
          :show-total="total => `共 ${total} 条`"
          @change="getDataItems"
        ></a-pagination>-->
      </a-tab-pane>
    </a-tabs>
<!--    <PicDialog ref="picDialog" :list="picList"></PicDialog>-->
  </div>
  </a-modal>
</template>
<script>
// import PicDialog from '../PicDialog'
import PicList from '../../DataPreparation/DataSet/PicList'
import { getDateTime, getTaskName, getStateName, getUserName } from '@/filters'
import { getDataByPage } from '@/api/dataItem'
import { mapState } from 'vuex'
import { getMyRelease } from '@/api/task'
import { getDataset } from '@/api/dataSet'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    // PicDialog
    PicList
  },
  data () {
    return {
      visible: false,
      info: {
        list1: [],
        list2: []
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      taskNumber: '--',
      subList: []
    }
  },
  computed: {
    ...mapState(['appConfig'])
  },
  methods: {
    getDateTime,
    getTaskName,
    getStateName,
    getUserName,
    open () {
      this.visible = true
      this.subList = []
      this.$nextTick(() => {
        // this.getInfo(1)
        // this.getDataItems()
        this.$refs.picList.reset()
      })
    },
    getInfo (id) {
      console.log(id)
      this.info = {
        id: id,
        name: '任务1',
        type: '目标检测',
        description: '说明内容',
        creator: 'name1',
        time: '2020-10-10 15:43:18',
        demandTime: '2020-10-20 15:43:18',
        total: 881,
        state: '已标注',
        smart: '启用',
        progress: '100/240',
        subTaskCount: 10,
        list1: [
          { name: '标注员1', value: 112 },
          { name: '标注员2', value: 112 },
          { name: '标注员3', value: 112 },
          { name: '标注员4', value: 112 }
        ],
        list2: [
          { name: '审核员1', value: 112 },
          { name: '审核员2', value: 112 }
        ]
      }
    },
    getDataItems () {
      const addition = this.addition
      const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
      getDataByPage({ ...this.page, ...params }).then(res => {
        /* const data = res.data.map.data
        this.taskNumber = data.total
        this.picList = data.rows
        this.total = data.total > params.pageSizeMax ? params.pageSizeMax - 0 : data.total
        this.getSubList() */
      })
    },
    getSubList () {
      getMyRelease({ pageNum: 1, pageSize: 1000, parentId: this.currentItem.id, field: 'name', order: 'asc' }).then(res => {
        const data = res.data.map.data
        for (let i = 0; i < data.rows.length; i++) {
          const obj = {}
          obj.taskName = data.rows[i].name
          obj.id = i
          obj.name = data.rows[i].excuteUserId ? data.rows[i].excuteUserId : '未分配'
          /* if (this.taskNumber % data.rows.length === 0) {
            obj.taskNum = this.taskNumber / data.rows.length
          } else {
            const ys = Math.floor(this.taskNumber / data.rows.length)
            if (i + 1 === data.rows.length) {
              obj.taskNum = this.taskNumber - (data.rows.length - 1) * ys
            } else {
              obj.taskNum = ys
            }
          } */
          getDataset({
            datasetId: data.rows[i].datasetId
          }).then(res => {
            obj.taskNum = res.total
            this.subList.push(obj)
            this.subList.sort(this.order)
          })
        }
      })
    },
    order (a, b) {
      if (a.id < b.id) {
        return -1
      } else if (a.id > b.id) {
        return 1
      } else if (a.id === b.id) {
        return 0
      }
    },
    openPicDialog (url) {
      this.$refs.picDialog.open(url)
    },
    setTotalCount (e) {
      this.taskNumber = e
      this.getSubList()
    }
  }
}
</script>
<style lang="less">
.dataset-detail {
  .info-wrap {
    display: flex; flex-wrap: wrap;
    .info-item {
      width: 25%;
      padding: 20px; box-sizing: border-box;
      display: flex;
      div:first-child{
        width: 100px;
        text-align: right;
      }
      div:last-child{
        width: calc(100% - 100px);
      }
    }
    .custom-table {
      width: 50%;
      padding: 20px; box-sizing: border-box;
      .table-row {
        padding:0 10px;
        display: flex;
        height: 50px;
        line-height: 50px;
      }
    }
    .tab{
      border-bottom:1px solid #f0f0f0;
      height: 40px;
      line-height: 40px;
      background: #fafafa;
    }
  }
  .pic-wrap {
    display: flex; flex-wrap: wrap;
    .pic-item {
      padding: 10px; box-sizing: border-box;
      width: 20%; text-align: center;
      img {
        width: 100%; height: 120px;
      }
    }
  }
}
</style>
